import { createI18n } from 'vue-i18n';
import zh_CN from '@/local/cn.json'
import en_US from '@/local/en.json'
import ko_KR from '@/local/ko.json'
import ja_JP from '@/local/jp.json'
import id_ID from '@/local/id.json'

const messages = {
    en_US,
    zh_CN,
    ko_KR,
    ja_JP,
    id_ID
};
//获取路径参数
const lan = localStorage.getItem('lang') || 'zh_CN';
const i18n = createI18n({
    locale: lan ,
    fallbackLocale: 'zh_CN', // 设置备用语言
    messages,
})

export default i18n;